import HoursInput from './HoursInput';

export default HoursInput;
